import { render, staticRenderFns } from "./select-meal-goods-order.vue?vue&type=template&id=73ef0540"
import script from "./select-meal-goods-order.vue?vue&type=script&lang=ts"
export * from "./select-meal-goods-order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports